// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1iviP","requiredAsterisk":"Info_requiredAsterisk__2H8QH"};